// CINEMAX - Mock Movie Data
// This data can be replaced with real API data later

export const MOVIE_GENRES = {
  ACTION: 'Acción',
  DRAMA: 'Drama',
  SCIFI: 'Ciencia Ficción',
  THRILLER: 'Thriller',
  COMEDY: 'Comedia',
  HORROR: 'Terror',
  ROMANCE: 'Romance',
  ANIMATION: 'Animación',
};

export const movies = [
  {
    id: 1,
    title: "Más Allá del Horizonte",
    originalTitle: "Beyond the Horizon",
    year: 2024,
    rating: 8.7,
    duration: "2h 28min",
    genres: [MOVIE_GENRES.SCIFI, MOVIE_GENRES.DRAMA],
    description: "En un futuro distante, una misión espacial descubre señales de vida inteligente más allá de nuestro sistema solar. Un equipo de astronautas debe enfrentar los límites de la humanidad mientras viajan hacia lo desconocido.",
    tagline: "El universo guarda secretos que cambiarán todo",
    poster: "https://images.unsplash.com/photo-1617195737496-bc30194e3a19?w=500&q=80",
    backdrop: "https://images.unsplash.com/photo-1617195737496-bc30194e3a19?w=1920&q=80",
    director: "Alejandra Vega",
    cast: ["María López", "Carlos Ruiz", "Ana Martínez"],
    maturity: "16+",
    featured: true,
  },
  {
    id: 2,
    title: "Sombras en la Ciudad",
    originalTitle: "City Shadows",
    year: 2024,
    rating: 8.4,
    duration: "2h 15min",
    genres: [MOVIE_GENRES.THRILLER, MOVIE_GENRES.ACTION],
    description: "Un detective retirado es arrastrado de vuelta al mundo del crimen cuando una serie de misteriosos asesinatos comienza a replicar casos sin resolver de su pasado.",
    tagline: "Algunos secretos nunca mueren",
    poster: "https://images.unsplash.com/photo-1608126199278-50a5f584dbdd?w=500&q=80",
    backdrop: "https://images.unsplash.com/photo-1608126199278-50a5f584dbdd?w=1920&q=80",
    director: "Roberto García",
    cast: ["Miguel Ángel Torres", "Laura Sánchez", "Pedro Navarro"],
    maturity: "18+",
    featured: true,
  },
  {
    id: 3,
    title: "El Último Guardián",
    originalTitle: "The Last Guardian",
    year: 2024,
    rating: 9.1,
    duration: "2h 45min",
    genres: [MOVIE_GENRES.ACTION, MOVIE_GENRES.SCIFI],
    description: "En un mundo devastado por la guerra, un héroe solitario emerge para proteger a los últimos supervivientes de una amenaza que podría acabar con toda la humanidad.",
    tagline: "La esperanza surge en la oscuridad",
    poster: "https://images.unsplash.com/photo-1635805737707-575885ab0820?w=500&q=80",
    backdrop: "https://images.unsplash.com/photo-1635805737707-575885ab0820?w=1920&q=80",
    director: "Elena Morales",
    cast: ["David Fernández", "Isabel Ruiz", "Jorge Martín"],
    maturity: "16+",
    featured: true,
  },
  {
    id: 4,
    title: "Venganza Silenciosa",
    originalTitle: "Silent Revenge",
    year: 2023,
    rating: 8.2,
    duration: "2h 05min",
    genres: [MOVIE_GENRES.ACTION, MOVIE_GENRES.THRILLER],
    description: "Un agente especial busca justicia por la muerte de su familia, descubriendo una conspiración que llega hasta los más altos niveles del gobierno.",
    tagline: "La venganza no conoce límites",
    poster: "https://images.unsplash.com/photo-1509347528160-9a9e33742cdb?w=500&q=80",
    backdrop: "https://images.unsplash.com/photo-1509347528160-9a9e33742cdb?w=1920&q=80",
    director: "Fernando Díaz",
    cast: ["Antonio Ramírez", "Carmen Vega", "Luis Ortega"],
    maturity: "18+",
    featured: false,
  },
  {
    id: 5,
    title: "Ecos del Pasado",
    originalTitle: "Echoes from the Past",
    year: 2024,
    rating: 8.6,
    duration: "2h 20min",
    genres: [MOVIE_GENRES.DRAMA, MOVIE_GENRES.THRILLER],
    description: "Una periodista investiga la desaparición de su hermana hace 20 años, desenterrando secretos familiares que pondrán su vida en peligro.",
    tagline: "El pasado siempre encuentra el camino de vuelta",
    poster: "https://images.unsplash.com/photo-1578429827733-272eb6d7972e?w=500&q=80",
    backdrop: "https://images.unsplash.com/photo-1578429827733-272eb6d7972e?w=1920&q=80",
    director: "Patricia Luna",
    cast: ["Sofía Hernández", "Marcos Delgado", "Teresa Blanco"],
    maturity: "16+",
    featured: true,
  },
  {
    id: 6,
    title: "Noche Infinita",
    originalTitle: "Endless Night",
    year: 2023,
    rating: 7.9,
    duration: "1h 58min",
    genres: [MOVIE_GENRES.HORROR, MOVIE_GENRES.THRILLER],
    description: "Un grupo de amigos queda atrapado en un pueblo abandonado donde las noches son eternas y algo antiguo acecha en las sombras.",
    tagline: "Cuando el sol muere, ellos despiertan",
    poster: "https://images.unsplash.com/photo-1610847455028-9e55e62bac33?w=500&q=80",
    backdrop: "https://images.unsplash.com/photo-1610847455028-9e55e62bac33?w=1920&q=80",
    director: "Ricardo Soto",
    cast: ["Andrea Gil", "Pablo Méndez", "Lucía Torres"],
    maturity: "18+",
    featured: false,
  },
  {
    id: 7,
    title: "Corazones de Acero",
    originalTitle: "Hearts of Steel",
    year: 2024,
    rating: 8.0,
    duration: "2h 35min",
    genres: [MOVIE_GENRES.ACTION, MOVIE_GENRES.DRAMA],
    description: "Durante la Segunda Guerra Mundial, un escuadrón de pilotos de caza debe superar sus diferencias para completar una misión suicida que podría cambiar el curso de la historia.",
    tagline: "El coraje no conoce nacionalidad",
    poster: "https://images.pexels.com/photos/2422588/pexels-photo-2422588.jpeg?w=500",
    backdrop: "https://images.pexels.com/photos/2422588/pexels-photo-2422588.jpeg?w=1920",
    director: "Javier Romero",
    cast: ["Eduardo Campos", "Marina Rivas", "Andrés Vera"],
    maturity: "16+",
    featured: false,
  },
  {
    id: 8,
    title: "La Última Frontera",
    originalTitle: "The Final Frontier",
    year: 2024,
    rating: 8.8,
    duration: "2h 40min",
    genres: [MOVIE_GENRES.SCIFI, MOVIE_GENRES.ACTION],
    description: "Colonos en Marte luchan por su supervivencia cuando pierden contacto con la Tierra y deben enfrentar una amenaza desconocida que emerge del planeta rojo.",
    tagline: "En el espacio, solo puedes confiar en ti mismo",
    poster: "https://images.pexels.com/photos/2611465/pexels-photo-2611465.jpeg?w=500",
    backdrop: "https://images.pexels.com/photos/2611465/pexels-photo-2611465.jpeg?w=1920",
    director: "Carolina Pérez",
    cast: ["Raúl Jiménez", "Elena Castillo", "Diego Moreno"],
    maturity: "16+",
    featured: true,
  },
  {
    id: 9,
    title: "Memorias Robadas",
    originalTitle: "Stolen Memories",
    year: 2023,
    rating: 8.3,
    duration: "2h 10min",
    genres: [MOVIE_GENRES.DRAMA, MOVIE_GENRES.ROMANCE],
    description: "Un hombre con amnesia se enamora de una mujer misteriosa, sin saber que ella guarda el secreto de su pasado olvidado.",
    tagline: "Algunos recuerdos valen la pena olvidar",
    poster: "https://images.pexels.com/photos/6896221/pexels-photo-6896221.jpeg?w=500",
    backdrop: "https://images.pexels.com/photos/6896221/pexels-photo-6896221.jpeg?w=1920",
    director: "Natalia Reyes",
    cast: ["Gabriel Montero", "Valentina Cruz", "Oscar Paredes"],
    maturity: "13+",
    featured: false,
  },
  {
    id: 10,
    title: "Código Oscuro",
    originalTitle: "Dark Code",
    year: 2024,
    rating: 8.5,
    duration: "2h 12min",
    genres: [MOVIE_GENRES.THRILLER, MOVIE_GENRES.SCIFI],
    description: "Una hacker descubre una inteligencia artificial que ha tomado control de infraestructuras críticas mundiales. Tiene 48 horas para detenerla antes del colapso total.",
    tagline: "El código que puede destruir el mundo",
    poster: "https://images.pexels.com/photos/6899772/pexels-photo-6899772.jpeg?w=500",
    backdrop: "https://images.pexels.com/photos/6899772/pexels-photo-6899772.jpeg?w=1920",
    director: "Martín Quiroga",
    cast: ["Julia Vargas", "Samuel Restrepo", "Camila Duarte"],
    maturity: "16+",
    featured: false,
  },
  {
    id: 11,
    title: "El Despertar",
    originalTitle: "The Awakening",
    year: 2024,
    rating: 7.8,
    duration: "1h 55min",
    genres: [MOVIE_GENRES.HORROR, MOVIE_GENRES.DRAMA],
    description: "Después de un accidente, una mujer comienza a ver espíritus de personas que murieron violentamente. Pronto descubre que tiene una misión: ayudarles a encontrar paz.",
    tagline: "Ver más allá de la muerte tiene un precio",
    poster: "https://images.pexels.com/photos/3137890/pexels-photo-3137890.jpeg?w=500",
    backdrop: "https://images.pexels.com/photos/3137890/pexels-photo-3137890.jpeg?w=1920",
    director: "Daniela Espinoza",
    cast: ["Renata Solís", "Ignacio Padilla", "Lorena Mejía"],
    maturity: "16+",
    featured: false,
  },
  {
    id: 12,
    title: "Persecución Mortal",
    originalTitle: "Deadly Pursuit",
    year: 2023,
    rating: 8.1,
    duration: "2h 08min",
    genres: [MOVIE_GENRES.ACTION, MOVIE_GENRES.THRILLER],
    description: "Un testigo protegido es perseguido por asesinos a sueldo mientras un marshall novato arriesga todo para mantenerlo con vida hasta el juicio.",
    tagline: "Corre o muere",
    poster: "https://images.pexels.com/photos/3532438/pexels-photo-3532438.jpeg?w=500",
    backdrop: "https://images.pexels.com/photos/3532438/pexels-photo-3532438.jpeg?w=1920",
    director: "Sergio Mendoza",
    cast: ["Nicolás Fuentes", "Alejandra Paz", "Rodrigo Salazar"],
    maturity: "18+",
    featured: false,
  },
  {
    id: 13,
    title: "Mundos Paralelos",
    originalTitle: "Parallel Worlds",
    year: 2024,
    rating: 8.9,
    duration: "2h 30min",
    genres: [MOVIE_GENRES.SCIFI, MOVIE_GENRES.DRAMA],
    description: "Un físico descubre la forma de viajar entre universos paralelos, pero cada viaje tiene consecuencias devastadoras que amenazan la existencia de todas las realidades.",
    tagline: "Infinitas posibilidades, una sola oportunidad",
    poster: "https://images.unsplash.com/photo-1674986634165-beb71dcc7c70?w=500&q=80",
    backdrop: "https://images.unsplash.com/photo-1674986634165-beb71dcc7c70?w=1920&q=80",
    director: "Isabel Cardona",
    cast: ["Mateo Silva", "Paulina Herrera", "Tomás Guerrero"],
    maturity: "13+",
    featured: true,
  },
  {
    id: 14,
    title: "Sin Retorno",
    originalTitle: "No Way Back",
    year: 2023,
    rating: 7.7,
    duration: "1h 52min",
    genres: [MOVIE_GENRES.THRILLER, MOVIE_GENRES.DRAMA],
    description: "Un padre desesperado cruza límites morales cuando su hija es secuestrada, descubriendo que los captores tienen conexiones con su propio pasado.",
    tagline: "Hasta dónde llegarías por tu familia",
    poster: "https://images.unsplash.com/photo-1634978767283-dad3afd8785b?w=500&q=80",
    backdrop: "https://images.unsplash.com/photo-1634978767283-dad3afd8785b?w=1920&q=80",
    director: "Francisco Torres",
    cast: ["Héctor Navarro", "Mónica Ríos", "Santiago Pardo"],
    maturity: "18+",
    featured: false,
  },
  {
    id: 15,
    title: "Aurora Boreal",
    originalTitle: "Northern Lights",
    year: 2024,
    rating: 8.4,
    duration: "2h 18min",
    genres: [MOVIE_GENRES.DRAMA, MOVIE_GENRES.ROMANCE],
    description: "En los paisajes helados de Noruega, dos almas perdidas encuentran amor y redención mientras huyen de sus pasados tormentosos.",
    tagline: "El amor florece donde menos lo esperas",
    poster: "https://images.unsplash.com/photo-1626814026160-2237a95fc5a0?w=500&q=80",
    backdrop: "https://images.unsplash.com/photo-1626814026160-2237a95fc5a0?w=1920&q=80",
    director: "Aurora Lindqvist",
    cast: ["Felipe Andersen", "Clara Johansen", "Erik Nilsen"],
    maturity: "13+",
    featured: false,
  },
];

// Get featured movies for hero carousel
export const getFeaturedMovies = () => movies.filter(movie => movie.featured);

// Get movies by genre
export const getMoviesByGenre = (genre) => movies.filter(movie => movie.genres.includes(genre));

// Get trending movies (highest rated)
export const getTrendingMovies = () => [...movies].sort((a, b) => b.rating - a.rating).slice(0, 10);

// Get top rated movies
export const getTopRatedMovies = () => [...movies].sort((a, b) => b.rating - a.rating);

// Get recent movies
export const getRecentMovies = () => [...movies].sort((a, b) => b.year - a.year);

// Normalize text (remove accents for search)
const normalizeText = (text) => {
  return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

// Search movies
export const searchMovies = (query) => {
  const searchTerm = normalizeText(query);
  return movies.filter(movie => 
    normalizeText(movie.title).includes(searchTerm) ||
    normalizeText(movie.originalTitle).includes(searchTerm) ||
    normalizeText(movie.director).includes(searchTerm) ||
    movie.cast.some(actor => normalizeText(actor).includes(searchTerm)) ||
    movie.genres.some(genre => normalizeText(genre).includes(searchTerm))
  );
};

// Get movie by ID
export const getMovieById = (id) => movies.find(movie => movie.id === parseInt(id));

// Category definitions for carousels
export const categories = [
  { id: 'trending', title: 'Tendencias', getMovies: getTrendingMovies },
  { id: 'top-rated', title: 'Mejor Valoradas', getMovies: getTopRatedMovies },
  { id: 'action', title: 'Acción', getMovies: () => getMoviesByGenre(MOVIE_GENRES.ACTION) },
  { id: 'drama', title: 'Drama', getMovies: () => getMoviesByGenre(MOVIE_GENRES.DRAMA) },
  { id: 'scifi', title: 'Ciencia Ficción', getMovies: () => getMoviesByGenre(MOVIE_GENRES.SCIFI) },
  { id: 'thriller', title: 'Thriller', getMovies: () => getMoviesByGenre(MOVIE_GENRES.THRILLER) },
];
